import React from "react";
import { Text, Switcher } from "@thecb/components";
import { SEMI_BOLD } from "@/constants/fonts";

const DisplayValue = ({ title, value }) => (
  <Switcher breakpoint="700px" childGap="0.25rem" largeChild={2} largeChildSize={5}>
    <Text variant="pS" weight={SEMI_BOLD} extraStyles="flex-basis: 17rem;">
      {title}
    </Text>
    <Text variant="pS" extraStyles="word-break: break-all;">
      {value}
    </Text>
  </Switcher>
);

export default DisplayValue;
